import { useEffect, useRef } from 'react'

const INTERVAL_MS = 150
const MAX_TRIES = 20

/**
 * Brengt het blok met het id uit de hash in beeld, zodra het zichtbaar is.
 *
 * Nodig omdat React Router bij een link als
 * `/personabuilder/<id>?tab=data#persona-traject` niet zelf naar de hash
 * scrolt, en het blok pas zichtbaar wordt nadat het tabblad is geopend (het
 * staat tot dan in een verborgen paneel). Daarom kijkt de hook een paar
 * seconden lang of het blok er is, scrolt één keer per hash, en geeft het
 * daarna op — een blok dat nooit komt laat geen timer achter.
 *
 * @param {string} hash - `location.hash`, bijv. '#persona-traject'; '' = niets doen
 */
const useScrollToHash = (hash) => {
    const done = useRef('')

    useEffect(() => {
        if (!hash || done.current === hash) return undefined
        const id = decodeURIComponent(hash.slice(1))
        let tries = 0

        const timer = setInterval(() => {
            tries += 1
            const el = document.getElementById(id)
            if (el && el.offsetParent !== null) {
                done.current = hash
                el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                clearInterval(timer)
            } else if (tries >= MAX_TRIES) {
                clearInterval(timer)
            }
        }, INTERVAL_MS)

        return () => clearInterval(timer)
    }, [hash])
}

export default useScrollToHash
